import { Flex, ScrollArea, Text } from "@mantine/core";
import { IIssueApi } from "@schemas/issueSchema";
import React from "react";
import { KanbanCard } from "../Kanban/KanbanCard/KanbanCard";

interface IssueMobileViewProps {
  issues: IIssueApi[];
  openContent: (issue: IIssueApi) => void;
}

const IssueMobileViewDefault: React.FC<IssueMobileViewProps> = ({ issues, openContent }) => {
  if (!issues?.length) {
    return (
      <Flex justify="center" align="center" h="100%" p="md">
        <Text c="dimmed" fw={500}>
          No issues found
        </Text>
      </Flex>
    );
  }

  return (
    <>
      <ScrollArea
        h="100%"
        type="auto"
        scrollbarSize={6}
        offsetScrollbars
        styles={{
          viewport: { padding: "0.5rem" },
        }}
      >
        <Flex wrap="wrap" justify="center" align="start" gap="xs">
          {issues.map((issue) => (
            <KanbanCard key={issue._id} content={issue} openContent={openContent} isMobile={true} />
          ))}
        </Flex>
      </ScrollArea>
    </>
  );
};

export default IssueMobileViewDefault;
